import type { ReactNode, ReactElement } from "react";
import JusCan, { getHashValue } from "../../services/jusCan";

type Props = {
  permissions?: Array<string>;
  children: ReactNode;
  renderNoAccess?: ReactNode;
  accountId?: string;
};

function Can({
  permissions = [],
  children = null,
  renderNoAccess = null,
  accountId = getHashValue(),
}: Props): ReactElement | null {
  const result = JusCan(permissions, accountId) ? children : renderNoAccess;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return result === null ? null : <>{result}</>;
}

export default Can;